<template>
  <div ref="mainInfo" class="main-info">
    <div class="main-info__wrapper">
      <ButtonBurger />
      <div class="main-info__catalog-menu">
        <ButtonCatalog />
        <RenderCacheable
          :max-age="86400"
          :cache-key="[getUserLanguage.name, getHash].join('--')"
        >
          <ModalCatalog
            class="main-info__catalog"
            :style="{
              '--bottom':
                heightCatalog > bottomValue - heightHeader
                  ? -(bottomValue - heightHeader) + 'px'
                  : -heightCatalog + 'px',
            }"
            @height-content="getHeightContent"
          />
        </RenderCacheable>
      </div>
      <Logo class="main-info__logo" />
      <Search />
      <ButtonLanguage />
      <NavigationMenu />
    </div>
  </div>
</template>

<script setup>
import ButtonBurger from "~~/modules/header/components/UI/ButtonBurger.vue";
import ButtonCatalog from "~~/modules/header/components/UI/ButtonCatalog.vue";
import Logo from "~~/modules/header/components/UI/Logo.vue";
import Search from "~/modules/header/components/UI/Search.vue";
import NavigationMenu from "~~/modules/header/sections/NavigationMenu.vue";
import ModalCatalog from "~~/modules/header/sections/ModalCatalog.vue";
import { addScopedEventListener } from "~~/utils/eventListener";
import ButtonLanguage from "~/modules/header/components/UI/ButtonLanguage.vue";
import { useLanguageStore } from "~/store/languageStore";
import { useCategoriesStore } from "~/store/categoriesStore";

const props = defineProps({
  heightHeader: { type: Number, required: false },
});

const emits = defineEmits(["getHeightMainInfo"]);

const languageStore = useLanguageStore();
const { getUserLanguage } = storeToRefs(languageStore);
const categoryStore = useCategoriesStore();
const { getHash } = storeToRefs(categoryStore);

const mainInfo = ref(null);

const heightCatalog = ref(0);
const bottomValue = ref(0);

function getPosition() {
  emits("getHeightMainInfo", mainInfo.value.offsetHeight);
  getPositionButton();
}

function getPositionButton() {
  bottomValue.value = document.documentElement.clientHeight;
}

function getHeightContent(value) {
  heightCatalog.value = value;
}

onMounted(() => {
  getPosition();
  addScopedEventListener(window, "resize", getPosition);
});
</script>

<style lang="scss" scoped>
.main-info {
  &__catalog {
    --bottom: 0;
    bottom: var(--bottom);
  }
}
</style>
